module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('input', {
    staticClass: "bb8-block-image-fileinput",
    attrs: {
      "tabindex": "-1",
      "name": "image[file]",
      "type": "file",
      "accept": "image/*",
      "required": _vm.block.fields.image == '',
      "id": 'bb8-file-' + _vm.index
    },
    on: {
      "change": function($event) {
        _vm.updateImage($event)
      }
    }
  }), " ", (_vm.block.fields.image != '') ? _h('div', {
    staticClass: "bb8-block-image-wrapper"
  }, [_h('div', {
    class: ['bb8-block-image-preview-wrapper', _vm.fields.alignment]
  }, [_h('img', {
    staticClass: "bb8-block-image-preview",
    attrs: {
      "src": _vm.block.fields.image
    }
  })]), " ", (!_vm.disallowAllignment) ? _h('div', {
    class: ['bb8-block-image-alignment', _vm.fields.alignment]
  }, [_h('svg', {
    staticClass: "icon icon-image-left",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.setAlignment('left')
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.setAlignment('left')
      }
    }
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-image-left"
    }
  })]), " ", _h('svg', {
    staticClass: "icon icon-image-center",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.setAlignment('center')
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.setAlignment('center')
      }
    }
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-image-center"
    }
  })]), " ", _h('svg', {
    staticClass: "icon icon-image-right",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.setAlignment('right')
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.setAlignment('right')
      }
    }
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-image-right"
    }
  })])]) : _vm._e(), " ", _h('a', {
    staticClass: "bb8-block-remove",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.removeBlock()
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.removeBlock()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]) : _vm._e(), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.block.fields.alt),
      expression: "block.fields.alt"
    }],
    staticClass: "bb8-form-control bb8-block-image-alt",
    attrs: {
      "placeholder": "Image caption",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.block.fields.alt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.block.fields.alt = $event.target.value
      }
    }
  }), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf523a98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/ImageBlock.vue
// module id = 49
// module chunks = 0